angular.module('tf.directives')
    .directive("tfLandingHeader",[function(){
        return {
            restrict: "E",
            replace:true,
            templateUrl: "js/components/landingHeader/landingHeader.html",
            controller : "LandingHeader"
        };

    }])
    .controller("LandingHeader",['$scope','$state',
        function($scope, $state){

        $scope.mobileMenu=false;

        $scope.setMobileMenu=function(state){
            $scope.mobileMenu=state;
        };

        }]);